import { render, staticRenderFns } from "./InfoElement.vue?vue&type=template&id=71a240c6&scoped=true&"
import script from "./InfoElement.vue?vue&type=script&lang=ts&"
export * from "./InfoElement.vue?vue&type=script&lang=ts&"
import style0 from "./InfoElement.vue?vue&type=style&index=0&id=71a240c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a240c6",
  null
  
)

export default component.exports